






















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { processServe } from '@/api/installServer';
import ShuttleOldBox from '@/components/shuttleBox/shuttleOldBox.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import logger from 'vuex/types/logger';

@Component({
  components: {
    ShuttleOldBox,
    CollapseTransition,
  },
})
export default class AuthorizationManagement extends Vue {
  @Prop() private unitData: any;
  @Prop() private formData: any;
  //权限管理表单
  authManage: any = {
    authOrgSeeSettings: '', //权限组查看权限的设置 0：所有人员均可查看、1：仅权限组内人员以及表单流程内相关人员可查看审批单）
    groupList: [
      {
        delAuth: false, //删除
        exportAuth: false, //导出
        flowFormId: this.unitData.id, //流程表单
        id: '',
        manageRange: '', //管理范围：自己负责的、全公司、同层级、下属的、自定义
        manageRangeCustomerOrgMember: '', //管理范围自定义组织机构成员
        name: '', //流程权限组的名称
        orgMember: [],
        seeAuth: false, //查看
      },
    ],
  };
  /**
   * @desc 新增权限组
   * @param1 无
   * @returns 无
   */
  addGroup() {
    this.authManage.groupList.push({
      delAuth: false,
      exportAuth: false,
      seeAuth: false,
      flowFormId: this.unitData.id,
      id: '',
      manageRange: '',
      manageRangeCustomerOrgMember: '',
      name: '',
      orgMember: [],
    });
  }
  /**
   * @desc 删除权限组
   * @param index 对应表单下标
   * @returns 无
   */
  del(index: any) {
    this.authManage.groupList.splice(index, 1);
  }
  /**
   * @desc 监听表单数据 向父组件发送表单数据
   */
  @Watch('authManage', { deep: true })
  private getAuth() {
    const data = {
      authManage: this.authManage,
      type: 'auth',
    };
    this.$emit('setFormData', data);
  }
  /**
   * @desc 获取部门人员
   * @param1 data 获取过来的数据
   * @returns 无
   */
  checkOldNodeData(data: any) {
    this.authManage.groupList.forEach((item: any) => {
      item.orgMember = data;
    });
  }
  /**
   * @desc 选择权限人员
   */
  authMember() {
    const shuttleOldBox = 'shuttleOldBox';
    const shuttleOldBoxComponent = this.$refs[shuttleOldBox];
    const orgArr = this.authManage.groupList.map((item: any) => item.orgMember);
    (shuttleOldBoxComponent as any).showDialog(orgArr);
  }
  mounted() {
    this.authManage = this.formData.authManage;
  }
}
